import { Navigate } from "react-router";

export default function GfsOfferIndexRoute() {
  return <Navigate to="overview" replace />;
}
